import { Component, OnInit } from '@angular/core';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { PageEvent } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import * as moment from 'moment';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.css']
})
export class ChangeLogComponent implements OnInit {
  displayFlag: boolean = true;
  public roleValue: any;
  public categories: any;
  public result: any;
  public documentTypes: any;
  public docTypesResult: any;
  public list: any;
  public logsList: any;
  public vendorLogs: any[] = [];
  public parLogs: any[] = [];
  length: any;
  ispaginationFlag: boolean = true;
  pageSize = 10;
  noResults: any;
  selected: any;
  agentName: any;
  selectedDocType: any;
  getLogsParams: any;
  agentToggleSelected: any;
  parToggleSelected: any;
  hideFlag: boolean = true;
  errMsg;
  errFlag: boolean = false;
  dataNotFoundMsg;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['DocumentCategory', 'DocumentType', 'TransactionType', 'FieldsEdited', 'ModifiedBy', 'ModifiedTimeStamp'];
  parcolumns = ['DocumentCategory', 'DocumentType', 'TransactionType', 'FieldsEdited', 'ModifiedBy', 'ModifiedTimeStamp'];
  dataSource: MatTableDataSource<UserData>;
  constructor(private changelogservice: ChangeLogService) { }
  pageEvent: PageEvent;
  ngOnInit() {
    this.roleValue = localStorage.getItem('RoleVal');
    this.agentToggleSelected = localStorage.getItem('agentClicked');
    this.agentName = localStorage.getItem("AgentName");
    this.parToggleSelected = localStorage.getItem('parClicked');
    if (this.roleValue == 1) {
      this.roleValue = this.roleValue;
      this.displayFlag = false;
    }
    else if ((this.roleValue == 4 || this.roleValue == 16) && (this.agentToggleSelected != "false" && this.agentToggleSelected != null && this.agentToggleSelected != undefined)) {
      this.displayFlag = false;
      this.roleValue = 1;
    }
    else if ((this.roleValue == 4 || this.roleValue == 16) && this.parToggleSelected == "true") {
      this.roleValue = 2;
      this.hideFlag = false;
    }
    this.bindLogsToGrid(this.roleValue);


  }
  bindLogsToGrid(roleValue) {
    this.changelogservice.getCategoryByRoleValue(this.roleValue).subscribe(res => {
      if (res.Status == 200 && res.Category !== undefined && res.Category[0] !== null) {
        this.categories = res['Category'];
        this.selected = this.categories[0];
        this.typeSelected(this.selected);
      }
      else if (res.Category !== undefined && res.Category[0] == null) {
        this.dataNotFoundMsg = "Category data not found";
        this.errFlag = true;
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });

  }


  typeSelected(categorySelected) {
    this.changelogservice.docsByCategory(categorySelected).subscribe(res => {
      if (res.Status == 200 && res.DocumentTypes !== undefined && res.DocumentTypes.length > 0) {
        this.documentTypes = res.DocumentTypes;
        this.docTypesResult = this.documentTypes.map(a => a.DocumentTypeName);
        this.docTypesResult = ["All", ...this.docTypesResult];
        localStorage.setItem('Category', categorySelected)
        this.selectedDocType = this.docTypesResult[0];
        this.doctypeselected(this.selectedDocType);
      }
      else if (res.DocumentTypes !== undefined && res.DocumentTypes.length == 0) {
        this.dataNotFoundMsg = "Document types data not found";
        this.errFlag = true;
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    })
  }

  convertCategroy(type) {
    if (this.roleValue == 1 || ((this.roleValue == 4 || this.roleValue == 16) && this.agentToggleSelected)) {
      switch (type) {
        case ("AGENTEMPLOYEE"):
          return 'Employee';
        case ("LICENSE"):
          return 'License';
        case ("DUEDILIGENCE"):
          return 'Due Diligence';
        case ("LOCATION"):
          return 'Location';
        case ("INSURANCE"):
          return 'Insurance';
      }
    }
    else {
      switch (type) {
        case ("PAREMPLOYEE"):
          return 'Employee';
        case ("PARLICENSE"):
          return 'License';
        case ("PARDUEDILIGENCE"):
          return 'Due Diligence';
        case ("PARINSURANCE"):
          return 'Insurance';
      }
    }

  }

  doctypeselected(docSelected) {
    this.changelogservice.getLogsList(docSelected).subscribe(res => {
      if (res.Status == 200 && res.Logs !== undefined && res.Logs.length > 0) {
        this.noResults = '';
        this.logsList = res.Logs;
        for (let i = 0; i < this.logsList.length; i++) {
          if (this.logsList[i].ModifiedTimeStamp != '' && this.logsList[i].ModifiedTimeStamp != null && this.logsList[i].ModifiedTimeStamp != undefined) {
            var momentDate = moment(this.logsList[i].ModifiedTimeStamp).format('YYYY/MM/DD');
            this.logsList[i].ModifiedTimeStamp = momentDate;
          }
        }
        for (let i = 0; i < this.logsList.length; i++) {
          if (this.logsList[i].IsVendorCompliant != '' || this.logsList[i].IsVendorCompliant != null || this.logsList[i].IsVendorCompliant == '') {
            this.logsList[i].IsVendorCompliant = (this.logsList[i].IsVendorCompliant == 'Y') ? this.logsList[i].IsVendorCompliant = 'Yes' : this.logsList[i].IsVendorCompliant = 'No';
          }
        }
        for (let i = 0; i < this.logsList.length; i++) {
          var regex = new RegExp(',', 'g');
          this.logsList[i].FieldsEdited = this.logsList[i].FieldsEdited.replace(regex, ", ")
        }
        this.vendorLogs = [];
        this.parLogs = [];
        for (let i = 0; i < this.logsList.length; i++) {
          if (this.roleValue == 1 && this.logsList[i].MasterVendorId !== undefined && this.logsList[i].MasterVendorId !== null && this.logsList[i].MasterVendorId !== '') {
            this.vendorLogs.push(this.logsList[i]);
            this.dataSource = new MatTableDataSource(this.vendorLogs);
            this.length = this.vendorLogs.length;
          }
          else if (this.roleValue == 2 && (this.logsList[i].MasterVendorId == undefined || this.logsList[i].MasterVendorId == null || this.logsList[i].MasterVendorId == '')) {
            this.parLogs.push(this.logsList[i]);
            this.dataSource = new MatTableDataSource(this.parLogs);
            this.length = this.parLogs.length;
          }
        }
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        this.paginator.pageIndex = 0;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
          const round = Math.ceil(length / 10)
          let pageOutput = `${(startIndex / 10) + 1}  of ${round}`;
          return pageOutput;
        }
        this.dataSource.paginator._intl = paginatorIntl;

      } else if (res.Logs !== undefined && res.Logs.length == 0) {
        this.logsList = [];
        this.dataSource = null;
        this.ispaginationFlag = false;
        this.noResults = "No logs found";
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }
}

export interface UserData {
  DocumentType: any;
  DocumentCategory: any;
  TransactionType: any;
  ModifiedBy: any;
  ModifiedTimeStamp: any;
  FieldsEdited: any;
}


// WEBPACK FOOTER //
// ./src/app/components/change-log/change-log.component.ts